import _slicedToArray from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { AutoRenewService } from '../../services/AutoRenewService.js';
import { SyncStorageService } from '../../services/SyncStorageService.js';
import { LeaderElectionService } from '../../services/LeaderElectionService.js';
import { RenewOnTabActivationService } from '../../services/RenewOnTabActivationService.js';
import { removeNils } from '../../util/object.js';
var AUTO_RENEW = 'autoRenew';
var SYNC_STORAGE = 'syncStorage';
var LEADER_ELECTION = 'leaderElection';
var RENEW_ON_TAB_ACTIVATION = 'renewOnTabActivation';
var ServiceManager = /*#__PURE__*/function () {
  function ServiceManager(sdk) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, ServiceManager);
    this.sdk = sdk;
    this.onLeader = this.onLeader.bind(this);
    var _sdk$tokenManager$get = sdk.tokenManager.getOptions(),
      autoRenew = _sdk$tokenManager$get.autoRenew,
      autoRemove = _sdk$tokenManager$get.autoRemove,
      syncStorage = _sdk$tokenManager$get.syncStorage;
    options.electionChannelName = options.electionChannelName || options.broadcastChannelName;
    this.options = Object.assign({}, ServiceManager.defaultOptions, {
      autoRenew: autoRenew,
      autoRemove: autoRemove,
      syncStorage: syncStorage
    }, {
      electionChannelName: "".concat(sdk.options.clientId, "-election"),
      syncChannelName: "".concat(sdk.options.clientId, "-sync")
    }, removeNils(options));
    this.started = false;
    this.services = new Map();
    ServiceManager.knownServices.forEach(function (name) {
      var svc = _this.createService(name);
      if (svc) {
        _this.services.set(name, svc);
      }
    });
  }
  return _createClass(ServiceManager, [{
    key: "onLeader",
    value: function () {
      var _onLeader = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.started) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return this.startServices();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function onLeader() {
        return _onLeader.apply(this, arguments);
      }
      return onLeader;
    }()
  }, {
    key: "isLeader",
    value: function isLeader() {
      var _a;
      return (_a = this.getService(LEADER_ELECTION)) === null || _a === void 0 ? void 0 : _a.isLeader();
    }
  }, {
    key: "isLeaderRequired",
    value: function isLeaderRequired() {
      return _toConsumableArray(this.services.values()).some(function (srv) {
        return srv.canStart() && srv.requiresLeadership();
      });
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.started) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.next = 4;
              return this.startServices();
            case 4:
              this.started = true;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function start() {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.stopServices();
            case 2:
              this.started = false;
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function stop() {
        return _stop.apply(this, arguments);
      }
      return stop;
    }()
  }, {
    key: "getService",
    value: function getService(name) {
      return this.services.get(name);
    }
  }, {
    key: "startServices",
    value: function () {
      var _startServices = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _iterator, _step, _step$value, name, srv;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _iterator = _createForOfIteratorHelper(this.services.entries());
              _context4.prev = 1;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context4.next = 10;
                break;
              }
              _step$value = _slicedToArray(_step.value, 2), name = _step$value[0], srv = _step$value[1];
              if (!this.canStartService(name, srv)) {
                _context4.next = 8;
                break;
              }
              _context4.next = 8;
              return srv.start();
            case 8:
              _context4.next = 3;
              break;
            case 10:
              _context4.next = 15;
              break;
            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](1);
              _iterator.e(_context4.t0);
            case 15:
              _context4.prev = 15;
              _iterator.f();
              return _context4.finish(15);
            case 18:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 12, 15, 18]]);
      }));
      function startServices() {
        return _startServices.apply(this, arguments);
      }
      return startServices;
    }()
  }, {
    key: "stopServices",
    value: function () {
      var _stopServices = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _iterator2, _step2, srv;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _iterator2 = _createForOfIteratorHelper(this.services.values());
              _context5.prev = 1;
              _iterator2.s();
            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context5.next = 9;
                break;
              }
              srv = _step2.value;
              _context5.next = 7;
              return srv.stop();
            case 7:
              _context5.next = 3;
              break;
            case 9:
              _context5.next = 14;
              break;
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](1);
              _iterator2.e(_context5.t0);
            case 14:
              _context5.prev = 14;
              _iterator2.f();
              return _context5.finish(14);
            case 17:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 11, 14, 17]]);
      }));
      function stopServices() {
        return _stopServices.apply(this, arguments);
      }
      return stopServices;
    }()
  }, {
    key: "canStartService",
    value: function canStartService(name, srv) {
      var canStart = srv.canStart() && !srv.isStarted();
      if (name === LEADER_ELECTION) {
        canStart && (canStart = this.isLeaderRequired());
      } else if (srv.requiresLeadership()) {
        canStart && (canStart = this.isLeader());
      }
      return canStart;
    }
  }, {
    key: "createService",
    value: function createService(name) {
      var tokenManager = this.sdk.tokenManager;
      var service;
      switch (name) {
        case LEADER_ELECTION:
          service = new LeaderElectionService(Object.assign(Object.assign({}, this.options), {
            onLeader: this.onLeader
          }));
          break;
        case AUTO_RENEW:
          service = new AutoRenewService(tokenManager, Object.assign({}, this.options));
          break;
        case SYNC_STORAGE:
          service = new SyncStorageService(tokenManager, Object.assign({}, this.options));
          break;
        case RENEW_ON_TAB_ACTIVATION:
          service = new RenewOnTabActivationService(tokenManager, Object.assign({}, this.options));
          break;
        default:
          throw new Error("Unknown service ".concat(name));
      }
      return service;
    }
  }]);
}();
ServiceManager.knownServices = [AUTO_RENEW, SYNC_STORAGE, LEADER_ELECTION, RENEW_ON_TAB_ACTIVATION];
ServiceManager.defaultOptions = {
  autoRenew: true,
  autoRemove: true,
  syncStorage: true,
  renewOnTabActivation: true,
  tabInactivityDuration: 1800
};
export { ServiceManager };